function makeNonce(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // randomUUID is undefined outside secure contexts; uniqueness within one
  // browser session is all this needs, so Math.random segments suffice.
  return `${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

/**
 * Identifies one page instance for the lifetime of the thumbnail-queue semaphore,
 * which is itself module-scope in useThumbnailQueue. Sharing that exact lifetime is
 * the point: loads sharing a nonce were admitted by one semaphore, so a burst of
 * starts is one queue's behaviour and not two tabs. Two tabs are two nonces.
 */
export const PAGE_LOAD_NONCE = makeNonce();
